import React from 'react';

interface Props {
    children?: string,
    className?: string
}

const ErrorText = ({ children, className }: Props) => {
    return (
        <div className={"errorText"}>
            <span className={className}>
                {children && children}
            </span>
        </div>
    )
}

export default ErrorText;